module.exports = __webpack_public_path__ + "img/ch1.bbf8b833.jpg";